import { SyntheticEvent } from 'react';

import { AsyncThunk } from '@reduxjs/toolkit';
import get from 'lodash/get';

import { useAppDispatch, useAppSelector } from '../../../../store/hooks';

export const useSearchHandlerEvent = <Returned, ThunkArg>(
  getThunk: AsyncThunk<Returned, ThunkArg, Record<string, unknown>>,
  filterPath: string
): ((event: SyntheticEvent) => void) => {
  const dispatch = useAppDispatch();

  const filters = useAppSelector(state => get(state, filterPath)).filters;

  return (event: SyntheticEvent) => {
    event.preventDefault();
    dispatch(getThunk(filters));
  };
};
